import React from 'react'
import { hashHistory } from 'react-router'
import { EXPERIENCE_SHOP_COOP_MANAGE } from '@constant'
import { getMoney } from '@hlj/hlj-utils'

export default [
  {
    title: '创建时间',
    dataIndex: 'firstDeductTime'
  },
  {
    title: '负责统筹师',
    dataIndex: ['merchantSupport', 'nick']
  },
  {
    title: '客户推荐时间',
    dataIndex: 'recommendAt'
  },
  {
    title: '用户/电话',
    dataIndex: 'user_info',
    render: (o, { userPhone, userName }) => {
      return (
        <div>
          <div>{userName}</div>
          <div>{userPhone}</div>
        </div>
      )
    }
  },
  {
    title: '合作订单金额',
    dataIndex: 'totalMoney',
    render: totalMoney => {
      return getMoney(totalMoney)
    }
  },
  {
    title: '已付服务费金额',
    dataIndex: 'brokerageSum',
    render: brokerageSum => {
      return getMoney(brokerageSum)
    }
  },
  {
    title: '操作',
    dataIndex: 'id',
    render: id => {
      return (
        <a
          onClick={() =>
            hashHistory.push(`${EXPERIENCE_SHOP_COOP_MANAGE}/detail/${id}`)
          }
        >
          订单详情
        </a>
      )
    }
  }
]
